export default [
  { display: 'Abortion Clinic', value: 'Abortion Clinic' },
  { display: 'Acupuncturist', value: 'Acupuncturist' },
  { display: 'Addiction Medicine Specialist', value: 'Addiction Medicine Specialist' },
  { display: 'Allergist', value: 'Allergist' },
  { display: 'Anesthesiologist', value: 'Anesthesiologist' },
  { display: 'Audiologist', value: 'Audiologist' },
  { display: 'Bariatrician', value: 'Bariatrician' },
  { display: 'Cardiologist', value: 'Cardiologist' },
  { display: 'Chiropractor', value: 'Chiropractor' },
  { display: 'Colon and Rectal Surgeon', value: 'Colon and Rectal Surgeon' },
  { display: 'Concierge Medicine', value: 'Concierge Medicine' },
  { display: 'Dental Hygienist', value: 'Dental Hygienist' },
  { display: 'Dentist (Cosmetic)', value: 'Cosmetic Dentist' },
  { display: 'Dentist (General)', value: 'General Dentist' },
  { display: 'Dentist (Pediatric)', value: 'Pediatric Dentist' },
  { display: 'Denturist', value: 'Denturist' },
  { display: 'Dermatologist', value: 'Dermatologist' },
  { display: 'Diagnostic Center', value: 'Diagnostic Center' },
  { display: 'Endocrinology and Metabolism Specialist', value: 'Endocrinology and Metabolism Specialist' },
  { display: 'Endodontist', value: 'Endodontist' },
  { display: 'Gastroenterologist', value: 'Gastroenterologist' },
  { display: 'General Practitioner', value: 'General Practitioner' },
  { display: 'General Surgeon', value: 'General Surgeon' },
  { display: 'Geriatrician', value: 'Geriatrician' },
  { display: 'Hand Surgeon', value: 'Hand Surgeon' },
  { display: 'Hematologist', value: 'Hematologist' },
  { display: 'Holistic Medicine Specialist', value: 'Holistic Medicine Specialist' },
  { display: 'Immunologist', value: 'Immunologist' },
  { display: 'Infectious Disease Specialist', value: 'Infectious Disease Specialist' },
  { display: 'Infertility Specialist', value: 'Infertility Specialist' },
  { display: 'Integrative Medicine Specialist', value: 'Integrative_Medicine_Specialist' },
  { display: 'Internist', value: 'Internist' },
  { display: 'Laser Eye Surgeon', value: 'Laser Eye Surgeon' },
  { display: 'Medical Assistant', value: 'Medical Assistant' },
  { display: 'Medical Clinic', value: 'Medical Clinic' },
  { display: 'Medical Spa', value: 'Medical Spa' },
  { display: 'Mobile Medical Provider', value: 'Mobile Medical Provider' },
  { display: 'Nephrologist', value: 'Nephrologist' },
  { display: 'Neurologist', value: 'Neurologist' },
  { display: 'Neurosurgeon', value: 'Neurosurgeon' },
  { display: 'Nurse Practitioner', value: 'Nurse Practitioner' },
  { display: 'Nutritionist', value: 'Nutritionist' },
  { display: 'Obstetrician and Gynecologist (OBGYN)', value: 'Obstetrician and Gynecologist' },
  { display: 'Occupational Medicine Specialist', value: 'Occupational Medicine Specialist' },
  { display: 'Oncologist', value: 'Oncologist' },
  { display: 'Ophthalmologist', value: 'Ophthalmologist' },
  { display: 'Optometrist', value: 'Optometrist' },
  { display: 'Oral Surgeon', value: 'Oral Surgeon' },
  { display: 'Orthodontist', value: 'Orthodontist' },
  { display: 'Orthopedic Surgeon', value: 'Orthopedic Surgeon' },
  { display: 'Osteopathic Physician', value: 'Osteopathic Physician' },
  { display: 'Otolaryngologist', value: 'Otolaryngologist' },
  { display: 'Pain Management Specialist', value: 'Pain Management Specialist' },
  { display: 'Pathologist', value: 'Pathologist' },
  { display: 'Pediatrician', value: 'Pediatrician' },
  { display: 'Periodontist', value: 'Periodontist' },
  { display: 'Pharmacist', value: 'Pharmacist' },
  { display: 'Physical Medicine and Rehab Specialist', value: 'Physical Medicine and Rehab Specialist' },
  { display: 'Physicians Assistant', value: 'Physicians Assistant' },
  { display: 'Plastic Surgeon', value: 'Plastic Surgeon' },
  { display: 'Podiatrist', value: 'Podiatrist' },
  { display: 'Preventive Medicine Specialist', value: 'Preventive Medicine Specialist' },
  { display: 'Primary Care Doctor', value: 'Primary Care Doctor' },
  { display: 'Proctologist', value: 'Proctologist' },
  { display: 'Prosthodontist', value: 'Prosthodontist' },
  { display: 'Psychiatrist', value: 'Psychiatrist' },
  { display: 'Psychologist', value: 'Psychologist' },
  { display: 'Pulmonologist', value: 'Pulmonologist' },
  { display: 'Radiologist', value: 'Radiologist' },
  { display: 'Rheumatologist', value: 'Rheumatologist' },
  { display: 'Sleep Medicine Specialist', value: 'Sleep Medicine Specialist' },
  { display: 'Sports Medicine Specialist', value: 'Sports Medicine Specialist' },
  { display: 'Urgent Care Specialist', value: 'Urgent Care Specialist' },
  { display: 'Urologist', value: 'Urologist' },
  { display: 'Vascular Surgeon', value: 'Vascular Surgeon' }
]



// WEBPACK FOOTER //
// ./src/data/specialties.js